import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureFlagDirective } from './feature-flag.directive';

/**
 * Módulo que exporta a diretiva FeatureFlag
 * 
 * Importe este módulo onde precisar usar a diretiva *appFeatureFlag
 */
@NgModule({
  declarations: [FeatureFlagDirective],
  imports: [CommonModule],
  exports: [FeatureFlagDirective]
})
export class FeatureFlagDirectiveModule {}
